import React from 'react';
function LayerArrowUp({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M17.0001 12.285L21.5001 14.13C21.654 14.2172 21.782 14.3437 21.8711 14.4965C21.9601 14.6494 22.0071 14.8231 22.0071 15C22.0071 15.1769 21.9601 15.3506 21.8711 15.5035C21.782 15.6563 21.654 15.7828 21.5001 15.87L13.0001 19.74C12.6961 19.9155 12.3512 20.0079 12.0001 20.0079C11.649 20.0079 11.3042 19.9155 11.0001 19.74L2.50011 15.87C2.34621 15.7828 2.21821 15.6563 2.12915 15.5035C2.04009 15.3506 1.99316 15.1769 1.99316 15C1.99316 14.8231 2.04009 14.6494 2.12915 14.4965C2.21821 14.3437 2.34621 14.2172 2.50011 14.13C2.50011 14.13 5.5 13 7.00011 12.285M12.0001 15V4M12.0001 4L17.0001 9M12.0001 4L7.00011 9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default LayerArrowUp;
